import { AitRowGroupData } from "./AitRowGroupData";
import { AitHeaderGroupData, AitTableData } from "./interface";

/**
 * Update the width of a column across header and body cells.
 *
 * This function returns a copy of the table data where the specified
 * `colNo` has its `colWidth` set to `colWidth` for every cell. The
 * `coreTrafficLight` is set to `ChangedUnknown` for modified rows and the
 * table to indicate a change.
 *
 * @template T - The cell payload type
 * @param table - The table data containing `headerData` and `bodyData`
 * @param colNo - Zero-based index of the column to update
 * @param colWidth - New width to apply to each cell in the column
 * @returns Object with updated `headerData` and `bodyData`
 */
export const trUpdateColumnWidth = <T>(
  table: AitTableData<T>,
  colNo: number,
  colWidth: number,
): {
  headerData: AitHeaderGroupData<T> | false;
  bodyData: AitRowGroupData<T>[];
} => {
  const newHeaderData: AitHeaderGroupData<T> | false =
    table.headerData !== undefined && table.headerData !== false
      ? {
          ...table.headerData,
          rows: table.headerData.rows.map((r) => ({
            ...r,
            cells: r.cells.map((c, ci) => ({
              ...c,
              colWidth: ci === colNo ? colWidth : c.colWidth,
              coreTrafficLight: "ChangedUnknown",
            })),
          })),
          coreTrafficLight: "ChangedUnknown",
        }
      : table.headerData;
  const newBodyData: AitRowGroupData<T>[] = table.bodyData.map((rg) => ({
    ...rg,
    rows: rg.rows.map((r) => ({
      ...r,
      cells: r.cells.map((c, ci) => ({
        ...c,
        colWidth: ci === colNo ? colWidth : c.colWidth,
        coreTrafficLight: "ChangedUnknown",
      })),
      coreTrafficLight: "ChangedUnknown",
    })),
    coreTrafficLight: "ChangedUnknown",
  }));
  return {
    headerData: newHeaderData,
    bodyData: newBodyData,
  };
};
